import { useRequiredContext } from "@redotech/react-util/context";
import DashboardIcon from "@redotech/redo-icons/dashboard.svg";
import DashboardFilledIcon from "@redotech/redo-icons/dashboard_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const DashboardItems = memo(function DashboardItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConversionSubRoute("dashboard") }}
      FilledIcon={DashboardFilledIcon}
      friendlyName="Dashboard"
      id="dashboard"
      UnfilledIcon={DashboardIcon}
    />
  );
});
